"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiSdk = void 0;
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
var js_api_sdk_1 = require("@sendspark/js-api-sdk");
var axios_1 = __importDefault(require("axios"));
exports.getApiSdk = (function () {
    var apiBaseUrl = process.env.API_V2_URL;
    var onRequest = function (configParam) {
        var newParams = configParam;
        newParams.baseURL = configParam.baseURL
            ? configParam.baseURL + "/api/v1"
            : apiBaseUrl + "/api/v1";
        newParams.headers.accept = 'application/json';
        newParams.withCredentials = false;
        return newParams;
    };
    var onRequestError = function (error) { return Promise.reject(error); };
    var axiosConfig = {
        baseURL: apiBaseUrl,
        withCredentials: false,
    };
    var axiosClient = axios_1.default.create(axiosConfig);
    axiosClient.interceptors.request.use(onRequest, onRequestError);
    return new js_api_sdk_1.DefaultApi({}, '', axiosClient);
})();
